import { sectionTone, type SectionTone } from './timelineGeometry';
import styles from './SectionTones.module.scss';

const TONE_CLASS: Readonly<Record<SectionTone, string | undefined>> = {
  intro: styles.intro,
  verse: styles.verse,
  chorus: styles.chorus,
  bridge: styles.bridge,
  outro: styles.outro,
};

/** The class that colours a section by its kind (design Timeline, f1). */
export function sectionToneClass(kind: string): string | undefined {
  return TONE_CLASS[sectionTone(kind)];
}
